var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g, _g2, _g3, _path53, _path54, _path55, _path56, _path57, _path58;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 595.28 596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 144.51,
    y: 194.4,
    width: 310.44,
    height: 299.77,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_1871_4470"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.5,323.24l108.99,60.35,144.01-82.88,17.45,35.84-227.3,130.81-83.14-42.45,39.99-101.66Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 173.79,
    y: 126.54,
    width: 288.22,
    height: 325.62,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1_1871_4470"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.79,317.31l119.7,66.28,165.95-95.5,2.58-143.6-110.47-17.96-172.9,120.57-4.86,70.2Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 173.79,
    y: 126.54,
    width: 288.22,
    height: 365.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask2_1871_4470"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.79,317.31l119.7,66.28,165.95-95.5,2.58-143.6-110.47-17.96-172.9,120.57-4.86,70.2Z",
    fill: "#fff"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M531.38,212.86l-24.29-14.03,24.29-14.03,24.29,14.03-24.29,14.03Z",
    fill: "#184143",
    isolation: "isolate",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M555.68,181.03l-24.29,14.03v-28.05l24.29-14.03v28.05Z",
    fill: "#1e4a57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M531.38,167l-24.29-14.03,24.29-14.03,24.29,14.03-24.29,14.02Z",
    fill: "#1e4a57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M531.38,195.05l-24.29-14.03v-28.05l24.29,14.03v28.05Z",
    fill: "#1e4a57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M522.63,179.9l-6.8-3.92v-7.84l6.8,3.92v7.85Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1,539.84l-25.29-14.6,25.29-14.6,25.29,14.6-25.29,14.6Z",
    fill: "#184143",
    isolation: "isolate",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.39,506.7l-25.29,14.6v-29.2l25.29-14.6v29.2Z",
    fill: "#184143"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1,492.1l-25.29-14.6,25.29-14.6,25.29,14.6-25.29,14.6Z",
    fill: "#d9efec"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1,521.3l-25.29-14.6v-29.2l25.29,14.6v29.2Z",
    fill: "#61c5bb"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.99,505.52l-7.07-4.08v-8.17l7.07,4.08v8.17Z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M342.57,524.57l65.23-37.66c5.15-2.97,13.51-3.15,20.27-.73l17.95-10.51c-16.84-12.55-18.37-29.73-4.58-43.12,2.7,3.81,6.69,7.39,12.05,10.48,21.6,12.47,56.63,12.47,78.23,0,8.43-4.87,13.52-10.92,15.37-17.23,24.64,15.06,24.2,38.8-1.33,53.54-25.23,14.56-65.62,14.95-91.74,1.25l-18.1,10.6c3.06,3.68,2.38,7.92-2.3,10.62l-65.23,37.66c-6.17,3.56-16.95,3.12-24.08-1-7.13-4.11-7.9-10.34-1.73-13.9Z",
    fill: "#184143",
    isolation: "isolate",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M531.73,406.22c-21.6-12.47-56.63-12.47-78.23,0-8.96,5.17-14.19,11.67-15.72,18.41,1.35,5.94,5.59,11.69,12.71,16.52,1.78-1.45,3.78-2.85,6.04-4.15,21.6-12.47,56.63-12.47,78.23,0,1.06.61,2.06,1.25,3.02,1.9,5.3-4.32,8.53-9.23,9.67-14.27-1.53-6.73-6.76-13.23-15.72-18.41Z",
    fill: "#d9efec",
    isolation: "isolate",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M436.47,434.58l8.44-11,25.63-11.91,22.08-1.96,25.86,3.16,17.94,9.27,11.46,7.31,2.06-11.91-3.87-13.72s-9.8-6.48-10.4-7.08c-.6-.6-22.91-8.59-22.91-8.59l-22.31-1.51-17.94,2.26-18.24,5.43-12.06,8.44-9.04,11.46-1.02,14.32,4.33,6.03Z",
    fill: "#1e4a57"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M556.12,420.45v23.18l-6.2-10.05,6.2-13.13Z",
    fill: "#1e4a57"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M453.5,421.65c21.6-12.47,56.63-12.47,78.23,0,6.8,3.92,11.45,8.61,13.97,13.59,1.9-1.7,4.35-3.04,5.37-5.34-3.09-4.21-7.6-8.16-13.55-11.6-24.8-14.32-65.01-14.32-89.81,0-5.43,3.13-9.67,6.69-12.72,10.49,1,2.33,2.52,4.59,4.53,6.46,2.52-4.98,7.17-9.68,13.98-13.61Z",
    fill: "#1e4a57"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M531.73,406.22c-21.6-12.47-56.63-12.47-78.23,0-8.96,5.17-14.19,11.68-15.72,18.41,1.53,6.73,6.76,13.24,15.72,18.41,21.6,12.47,56.63,12.47,78.23,0,8.96-5.17,14.19-11.68,15.72-18.41-1.53-6.73-6.76-13.24-15.72-18.41Z",
    fill: "#d9efec",
    isolation: "isolate",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M551.07,429.9c-.43.98-1.13,1.77-1.93,2.51l-.02-.24-5.73,3.42-7.04,6.53-9.75,4.32-13.47,4.82-11.96,2.81-16.48.7-10.65-1.11-21.1-5.53-13.75-12.16c.11-.24.2-.49.32-.73-2.02-1.86-3.53-4.12-4.53-6.46-.37.46-.72.93-1.06,1.4l-4.82-10.04v24.08-.02c0,9.39,6.19,18.78,18.6,25.95,24.8,14.32,65.01,14.32,89.81,0,18.85-10.88,23.36-26.91,13.55-40.26Z",
    fill: "#1e4a57"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M444.15,440.37l-4.96-4.38c.11-.24.2-.49.32-.73-2.02-1.86-3.53-4.12-4.53-6.46-.37.46-.72.93-1.06,1.4l-4.82-10.04v24.08-.02c0,8.44,5.02,16.88,15.05,23.71v-27.55h0Z",
    fill: "#1e4a57"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M537.52,394.52c-24.8-14.32-65.01-14.32-89.81,0-24.8,14.32-24.8,37.53,0,51.85,24.8,14.32,65.01,14.32,89.81,0,24.8-14.32,24.8-37.54,0-51.85ZM531.73,443.03c-21.6,12.47-56.63,12.47-78.23,0-21.6-12.47-21.6-32.7,0-45.17,21.6-12.47,56.63-12.47,78.23,0,21.6,12.47,21.6,32.7,0,45.17Z",
    fill: "#1e4a57"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M406.17,472.65l35.2-20.48,4.68,7.58-35.36,20.59-4.52-7.69Z",
    fill: "#d9efec"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M411.58,478.32c0,2.01-1.41,2.83-3.16,1.82-1.74-1.01-3.16-3.45-3.16-5.46s1.41-2.83,3.16-1.82c1.74,1.01,3.16,3.45,3.16,5.46Z",
    fill: "#6356a4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M411.58,478.32c0,2.01-1.41,2.83-3.16,1.82-1.74-1.01-3.16-3.45-3.16-5.46s1.41-2.83,3.16-1.82c1.74,1.01,3.16,3.45,3.16,5.46Z",
    fill: "#6356a4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M446.79,457.83c0,2.01-1.41,2.83-3.16,1.82s-3.16-3.45-3.16-5.46,1.41-2.83,3.16-1.82c1.74,1.01,3.16,3.45,3.16,5.46Z",
    fill: "#d9efec"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M428.9,479.8c0-8.66-6.08-19.19-13.58-23.52-3.84-2.22-7.3-2.37-9.77-.84h0s-74.42,43.24-74.42,43.24l19.45,33.1,73.63-42.87c.51-.22.98-.49,1.42-.82l.06-.04h0c2-1.58,3.21-4.41,3.21-8.26Z",
    fill: "#61c5bb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M336.52,507.86l83.29-48.09c-1.41-1.38-2.91-2.58-4.49-3.49-3.84-2.22-7.3-2.37-9.77-.84h0s-74.42,43.24-74.42,43.24l5.38,9.17Z",
    fill: "#d9efec"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M350.44,531.88c5.3-3.06,5.3-12.99,0-22.17-5.3-9.18-13.9-14.15-19.2-11.08-5.3,3.06-5.3,12.99,0,22.17,5.3,9.18,13.9,14.15,19.2,11.08Z",
    fill: "#d9efec"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M343.41,519.04c0,4.88-3.96,8.84-8.84,8.84s-8.84-3.96-8.84-8.84,3.96-8.84,8.84-8.84,8.84,3.96,8.84,8.84Z",
    fill: "#61c5bb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M332.94,515.8c0,1.44-1.17,2.61-2.61,2.61s-2.61-1.17-2.61-2.61,1.17-2.61,2.61-2.61,2.61,1.17,2.61,2.61Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M341.85,498.99c-4.01-2.32-7.61-2.37-10.09-.61,2.41-1.12,5.59-.83,9.09,1.19,7.5,4.33,13.58,14.86,13.58,23.52,0,4.03-1.33,6.92-3.49,8.45,2.75-1.28,4.49-4.41,4.49-9.03,0-8.66-6.08-19.19-13.58-23.52Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M531.73,397.86c-21.6-12.47-56.63-12.47-78.23,0-11.25,6.5-16.63,15.09-16.16,23.6.43-7.83,5.81-15.59,16.16-21.57,21.6-12.47,56.63-12.47,78.23,0,10.35,5.98,15.73,13.74,16.16,21.57.47-8.51-4.91-17.11-16.16-23.6Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M537.52,446.37c-24.8,14.32-65.01,14.32-89.81,0-11.95-6.9-18.13-15.87-18.56-24.91-.46,9.72,5.71,19.53,18.56,26.94,24.8,14.32,65.01,14.32,89.81,0,12.85-7.42,19.02-17.22,18.56-26.94-.43,9.04-6.61,18.01-18.56,24.91Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M561.08,321.42l-157.53-91.22c-8.56-4.96-23.52-4.36-33.41,1.34L39.53,421.8c-9.9,5.69-10.98,14.33-2.43,19.29l157.53,91.22c8.56,4.96,23.52,4.36,33.41-1.34l330.61-190.26c9.9-5.7,10.98-14.33,2.43-19.29Z",
    fill: "#184143",
    isolation: "isolate",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M190.05,498.52L26.11,403.58c-5.39-3.12-7.9-7.32-7.72-11.7h-.04s.07-23.78.07-23.78l9.12,10.68c.59-.39,1.19-.78,1.83-1.15l335.37-193c13.32-7.66,33.44-8.47,44.95-1.8l161.64,93.6c3.27-3.58,10.13-11.15,10.13-11.15l-.08,23.27h0c.24,5.24-3.49,10.83-11.01,15.16l-335.37,193c-13.31,7.66-33.44,8.47-44.95,1.8Z",
    fill: "#1e4a57"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.4,440.28l9.44,5.45c1.25.72,2.27-.05,2.27-1.72s-1.02-3.61-2.27-4.34l-9.44-5.45c-1.25-.72-2.27.04-2.27,1.72,0,1.67,1.02,3.61,2.27,4.34Z",
    fill: "#184143"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M364.74,184.63c13.31-7.66,33.44-8.47,44.95-1.8l161.64,93.6c3.27-3.58,10.13-11.15,10.13-11.15l-.08,23.27h0c.24,5.24-3.49,10.83-11.01,15.16l-335.37,193.01c-6.95,4-15.74,6.11-24.21,6.29l.32-229.96,153.63-88.41Z",
    fill: "#61c5bb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M573.71,253.85l-163.94-94.93c-11.51-6.67-31.64-5.86-44.95,1.8L29.45,353.72c-13.32,7.66-14.78,19.28-3.26,25.95l163.94,94.94c11.51,6.67,31.64,5.86,44.95-1.8l335.37-193.01c13.32-7.66,14.78-19.28,3.26-25.95Z",
    fill: "#d9efec"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M190,477.14L26.06,382.2c-5.94-3.44-8.4-8.19-7.59-13.04.29,3.94,2.82,7.67,7.71,10.51l163.94,94.94c11.51,6.67,31.64,5.86,44.95-1.8l335.37-193.01c6.45-3.71,10.09-8.35,10.85-12.9.39,5.33-3.32,11.04-10.97,15.44l-335.37,193.01c-13.32,7.66-33.44,8.47-44.95,1.8Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M561.08,257.59l-157.53-91.22c-8.56-4.96-23.52-4.36-33.41,1.34L39.53,357.97c-9.9,5.7-10.98,14.33-2.43,19.29l157.53,91.22c8.56,4.96,23.52,4.36,33.41-1.34l330.61-190.26c9.9-5.7,10.98-14.33,2.43-19.29Z",
    fill: "#184143"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M234.32,421.1l-111.16-64.18,7.09-4.1,111.16,64.18-7.09,4.1Z",
    fill: "#d9efec"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M156.97,402.39l-56.28-32.5,7.09-4.1,56.28,32.5-7.09,4.1Z",
    fill: "#d9efec"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M184.29,418.16l-18.25-10.54,7.09-4.1,18.25,10.54-7.09,4.1Z",
    fill: "#1e4a57"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M211.85,434.07l-18.25-10.54,7.09-4.1,18.25,10.54-7.09,4.1Z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M157.6,389.78l-45.68-26.37,7.09-4.1,45.68,26.37-7.1,4.1Z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M213.36,421.97l-45.68-26.37,7.1-4.1,45.68,26.37-7.09,4.1Z",
    fill: "#d9efec"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M179.54,365.6c-2.29,1.32-5.99,1.32-8.28,0-2.29-1.32-2.29-3.46,0-4.78,2.29-1.32,5.99-1.32,8.28,0,2.29,1.32,2.29,3.46,0,4.78Z",
    fill: "#1e4a57"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M191.91,372.74c-2.29,1.32-5.99,1.32-8.28,0-2.29-1.32-2.29-3.46,0-4.78,2.29-1.32,5.99-1.32,8.28,0,2.29,1.32,2.29,3.46,0,4.78Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M204.28,379.88c-2.29,1.32-5.99,1.32-8.28,0-2.29-1.32-2.29-3.46,0-4.78,2.29-1.32,5.99-1.32,8.28,0,2.29,1.32,2.29,3.46,0,4.78Z",
    fill: "#d9efec"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M216.65,387.02c-2.29,1.32-5.99,1.32-8.28,0-2.29-1.32-2.29-3.46,0-4.78,2.29-1.32,5.99-1.32,8.28,0,2.29,1.32,2.29,3.46,0,4.78Z",
    fill: "#1e4a57"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M229.02,394.16c-2.29,1.32-5.99,1.32-8.28,0-2.29-1.32-2.29-3.46,0-4.78,2.29-1.32,5.99-1.32,8.28,0,2.29,1.32,2.29,3.46,0,4.78Z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M477.63,258.29l-18.72-10.81,7.28-4.2,18.72,10.81-7.28,4.2Z",
    fill: "#1e4a57"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M503.69,273.34l-18.72-10.81,7.27-4.2,18.72,10.81-7.27,4.2Z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M394.03,209.57l-18.72-10.81,7.27-4.2,18.72,10.81-7.28,4.2Z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M473.46,269.18l-26.06-15.05,7.28-4.2,26.06,15.05-7.27,4.2Z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M492.18,279.99l-11.44-6.6,7.27-4.2,11.44,6.6-7.27,4.2Z",
    fill: "#d9efec"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.46,348.64c-5.96,3.44-5.96,9.04,0,12.49l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43l-101.36-58.52c-2.69-1.55-2.69-4.08,0-5.63l9.82-5.67c-1.09-1.64-2.08-3.35-3.05-5.09l-12.71,7.34Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.02,395.29l-101.36-58.52c-5.96-3.44-15.67-3.44-21.63,0l-7.86,4.54c.97,1.74,1.96,3.45,3.05,5.09l10.75-6.2c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.24,397.13v-142.54s-106.21-59.22-106.21-59.22l-14.85-.98-14.37,9.31-8.81,7.67,103.49,164.12,33.79,19.92,6.96,1.71Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.96,415.13l31.75-18.33v-137.75l-32.73,15.21.98,140.87Z",
    fill: "#87d0c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.99,212.48v142.3l111.51,63.79,1.49-.59v-142.51l-113-62.98Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.98,273.22v147.14c1.01-.03,2.01-.25,2.78-.7.81-.47,1.21-1.07,1.22-1.68h0v-.03h0v-142.49l-4.01-2.24Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,344.61l-52.67-30.41v-52.8l52.67,30.41v52.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,376.23c-5.96,3.44-5.96,9.04,0,12.49l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43l-101.36-58.52c-2.69-1.55-2.69-4.08,0-5.63l9.82-5.67c-1.09-1.64-2.08-3.35-3.05-5.09l-12.71,7.34Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.42,422.88l-101.36-58.52c-5.96-3.44-15.67-3.44-21.63,0l-7.86,4.54c.97,1.74,1.96,3.45,3.05,5.09l10.75-6.2c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.64,424.72v-142.54s-106.21-59.22-106.21-59.22l-14.86-.98-14.37,9.31-8.81,7.67,103.5,164.12,33.79,19.91,6.96,1.72Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.36,442.72l31.75-18.33v-137.75l-32.73,15.21.98,140.87Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.39,240.07v142.3l111.51,63.79,1.49-.6v-142.51l-113-62.98Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.11,241.24l-22.16-12.73c-2.71-1.25-6.66-1.17-9.17.27l-20.57,11.88c-1.59.92-2.23,2.18-1.94,3.38l56,33.46,44.98,27.61,31.86-18.48-79-45.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.38,300.81v147.14c1.01-.03,2.01-.25,2.78-.7.81-.47,1.21-1.07,1.22-1.68h0v-.03h0v-142.49l-4.01-2.24Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,304.89v-1.82l-.55.77.55,1.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.22,304.73l-101.36-58.52c-5.96-3.44-5.96-9.04,0-12.49l20.57-11.88c5.96-3.44,15.67-3.44,21.63,0l101.36,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.69-1.55-7.06-1.55-9.76,0l-20.57,11.88c-2.69,1.55-2.69,4.08,0,5.63l101.36,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,372.2l-52.67-30.41v-52.8l52.67,30.41v52.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,304.74c-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.57-1.48-4.02-3.37-4.38-5.31-.47,2.56.98,5.22,4.38,7.18l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.2.28-.5.55-.9.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.97,422.44c-5.96,3.44-5.96,9.04,0,12.49l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43l-101.36-58.52c-2.69-1.55-2.69-4.08,0-5.63l9.82-5.67c-1.09-1.64-2.08-3.35-3.05-5.09l-12.71,7.34Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.54,469.09l-101.36-58.52c-5.96-3.44-15.67-3.44-21.63,0l-7.86,4.54c.97,1.74,1.96,3.45,3.05,5.09l10.75-6.2c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.76,470.93v-142.54s-106.21-59.22-106.21-59.22l-14.86-.98-14.37,9.31-8.81,7.67,103.5,164.12,33.79,19.92,6.96,1.71Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,488.93l31.75-18.33v-137.75l-32.73,15.21.98,140.87Z",
    fill: "#87d0c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,286.28v142.3l111.51,63.79,1.49-.59v-142.51l-113-62.98Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,287.46l-22.16-12.73c-2.71-1.25-6.66-1.17-9.17.27l-20.57,11.88c-1.59.92-2.23,2.18-1.94,3.38l56,33.46,44.98,27.61,31.86-18.48-79-45.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.49,347.02v147.14c1.01-.03,2.01-.25,2.78-.7.81-.47,1.21-1.07,1.22-1.68h0v-.03h0v-142.49l-4.01-2.24Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.77,330.17v-1.78h-.57l-.17,1.21.74.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5,351.11v-1.82l-.55.77.55,1.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.34,350.95l-101.37-58.52c-5.96-3.44-5.96-9.04,0-12.49l20.57-11.88c5.96-3.44,15.67-3.44,21.63,0l101.36,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.69-1.55-7.06-1.55-9.76,0l-20.57,11.88c-2.69,1.55-2.69,4.08,0,5.63l101.36,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.92,418.41l-52.67-30.41v-52.8l52.67,30.41v52.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.54,330.01c-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.69-1.55-7.06-1.55-9.76,0l-20.57,11.88c-1.76,1.02-2.36,2.45-1.82,3.75.29-.69.89-1.34,1.82-1.88l20.57-11.88c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.2.28-.5.54-.9.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.28,350.95c-1.64.95-4.3.95-5.94,0l-101.37-58.52c-2.57-1.48-4.02-3.37-4.38-5.31-.47,2.56.98,5.22,4.38,7.18l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.2.28-.5.55-.9.78Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.27,290.39l-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,18.62-23.97,18.62,2.47-4.93-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#e67925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.51,304.08l-10.11-5.8-15.61,7.28s.05,10.5,0,10.75,6.44.56,6.87.56,18.85-12.79,18.85-12.79Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,367.31l10.11,5.8,4.93-27.55s-4.9-5.17-4.88-5.17-5.51.94-5.51.94l-4.65,25.98Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.38,296.2l-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,18.62-23.97,18.62,2.47-4.93-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.74,370.57l4.64-25.94-14.99-6.11,19.81-13.63,7.48-24.54,7.44,15.82,20.87-9.74,1.51-2.36-21.66,10.11-8.46-17.99-8.46,27.76-21.66,14.91,16.43,6.7-4.93,27.55,1.98-2.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.38,296.2l-10.11-5.8-8.46,27.76,10.11,5.8,8.46-27.76Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,333.06l10.11,5.8,21.66-14.91-10.11-5.8-21.66,14.91Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.41,324.65l1.54-.89-10.92-6.35-.23.74-.72.49,10.32,6.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.22,329.92l-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,18.62-23.97,18.62,2.47-4.93-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#e67925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.46,343.6l-10.11-5.8-15.61,7.28s.05,10.5,0,10.75c-.05.25,6.43.56,6.87.56.44,0,18.85-12.79,18.85-12.79Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.6,406.84l10.11,5.8,4.92-27.55s-4.9-5.17-4.88-5.17-5.51.94-5.51.94l-4.64,25.98Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.33,335.72l-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,18.62-23.97,18.62,2.47-4.93-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.69,410.09l4.64-25.94-14.99-6.11,19.81-13.63,7.48-24.54,7.44,15.82,20.87-9.74,1.51-2.36-21.66,10.11-8.46-17.99-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,1.98-2.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.33,335.72l-10.11-5.8-8.46,27.76,10.11,5.8,8.46-27.76Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,372.58l10.11,5.8,21.66-14.91-10.11-5.8-21.66,14.91Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.36,364.18l1.54-.89-10.92-6.35-.23.74-.72.49,10.32,6.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.17,369.44l-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,18.62-23.97,18.62,2.47-4.93-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#e67925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41,383.13l-10.11-5.8-15.61,7.28s.05,10.5,0,10.75c-.05.25,6.43.56,6.87.56.44,0,18.85-12.79,18.85-12.79Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.28,375.24l-8.46,27.76-21.66,14.91,16.43,6.7-4.93,27.55,18.62-23.97,18.62,2.47-4.93-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.64,449.62l4.64-25.94-14.99-6.11,19.81-13.63,7.48-24.54,7.44,15.82,20.87-9.74,1.51-2.36-21.66,10.11-8.46-17.99-8.46,27.76-21.66,14.91,16.43,6.7-4.93,27.55,1.98-2.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.28,375.24l-10.11-5.8-8.46,27.76,10.11,5.8,8.46-27.76Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.23,224.85l-8.46,27.76-21.66,14.91,16.43,6.7-4.93,27.55,18.62-23.97,18.62,2.47-4.92-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#e67925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.46,238.54l-10.11-5.8-15.61,7.28s.05,10.5,0,10.75c-.05.25,6.44.56,6.87.56s18.85-12.79,18.85-12.79Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.61,301.77l10.11,5.8,4.92-27.55s-4.9-5.17-4.88-5.17-5.51.94-5.51.94l-4.64,25.98Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.34,230.65l-8.46,27.76-21.66,14.91,16.43,6.7-4.93,27.55,18.62-23.97,18.62,2.47-4.92-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.69,305.03l4.64-25.94-14.99-6.11,19.81-13.63,7.48-24.54,7.44,15.82,20.87-9.74,1.51-2.36-21.66,10.11-8.46-17.99-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,1.98-2.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.34,230.65l-10.11-5.8-8.46,27.76,10.11,5.8,8.46-27.76Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.1,267.52l10.11,5.8,21.66-14.91-10.11-5.8-21.66,14.91Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.37,259.11l1.54-.89-10.92-6.35-.23.74-.72.49,10.32,6.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.18,264.37l-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,18.62-23.97,18.62,2.47-4.92-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#e67925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.42,278.06l-10.11-5.8-15.61,7.28s.05,10.5,0,10.75,6.44.56,6.87.56,18.85-12.79,18.85-12.79Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,341.29l10.11,5.8,4.93-27.55s-4.9-5.17-4.88-5.17-5.51.94-5.51.94l-4.65,25.98Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29,270.18l-8.46,27.76-21.66,14.91,16.43,6.7-4.92,27.55,18.62-23.97,18.62,2.47-4.92-21.86,16.43-25.67-21.66,10.11-8.46-17.99Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.64,344.55l4.64-25.94-14.99-6.11,19.81-13.63,7.48-24.54,7.44,15.82,20.87-9.74,1.51-2.36-21.66,10.11-8.46-17.99-8.46,27.76-21.66,14.91,16.43,6.7-4.93,27.55,1.98-2.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29,270.18l-10.11-5.8-8.46,27.76,10.11,5.8,8.46-27.76Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.05,307.04l10.11,5.8,21.66-14.91-10.11-5.8-21.66,14.91Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,298.63l1.54-.89-10.92-6.35-.23.74-.72.49,10.32,6.01Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.46,318.1c-5.96,3.44-5.96,9.04,0,12.49l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43l-101.36-58.52c-2.69-1.55-2.69-4.08,0-5.63l9.82-5.67c-1.09-1.64-2.08-3.35-3.05-5.09l-12.71,7.34Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.02,364.75l-101.36-58.52c-5.96-3.44-15.67-3.44-21.63,0l-7.86,4.54c.97,1.74,1.96,3.45,3.05,5.09l10.75-6.2c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.24,366.59v-142.54s-106.21-59.22-106.21-59.22l-14.85-.98-14.37,9.3-8.81,7.67,103.49,164.12,33.79,19.92,6.96,1.72Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.96,384.59l31.75-18.33v-137.75l-32.73,15.21.98,140.87Z",
    fill: "#87d0c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.99,181.94v142.3l111.51,63.79,1.49-.6v-142.51l-113-62.98Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.71,183.12l-22.16-12.73c-2.71-1.25-6.66-1.17-9.17.27l-20.57,11.88c-1.59.92-2.23,2.18-1.94,3.38l56,33.46,44.98,27.61,31.86-18.48-79-45.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.98,242.68v147.14c1.01-.03,2.01-.25,2.78-.7.81-.47,1.21-1.07,1.22-1.68h0v-.03h0v-142.49l-4.01-2.24Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.25,225.83v-1.78h-.57l-.17,1.21.74.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.99,246.77v-1.82l-.55.77.55,1.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.83,246.61l-101.37-58.52c-5.96-3.44-5.96-9.04,0-12.49l20.57-11.88c5.96-3.44,15.67-3.44,21.63,0l101.37,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0l-101.37-58.52c-2.69-1.55-7.06-1.55-9.75,0l-20.57,11.88c-2.69,1.55-2.69,4.08,0,5.63l101.37,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.41,314.07l-52.67-30.41v-52.8l52.67,30.41v52.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.03,225.67c-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.69-1.55-7.06-1.55-9.76,0l-20.57,11.88c-1.76,1.02-2.36,2.45-1.82,3.75.29-.69.89-1.34,1.82-1.88l20.57-11.88c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.2.28-.5.55-.9.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.77,246.61c-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.57-1.48-4.02-3.37-4.38-5.31-.47,2.56.98,5.22,4.38,7.18l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.21.28-.5.55-.9.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,376.23c-5.96,3.44-5.96,9.04,0,12.49l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43l-101.36-58.52c-2.69-1.55-2.69-4.08,0-5.63l9.82-5.67c-1.09-1.64-2.08-3.35-3.05-5.09l-12.71,7.34Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.42,422.88l-101.36-58.52c-5.96-3.44-15.67-3.44-21.63,0l-7.86,4.54c.97,1.74,1.96,3.45,3.05,5.09l10.75-6.2c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.64-.95,1.64-2.48,0-3.43Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.64,424.72v-142.54s-106.21-59.22-106.21-59.22l-14.86-.98-14.37,9.31-8.81,7.67,103.5,164.12,33.79,19.91,6.96,1.72Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.36,442.72l31.75-18.33v-137.75l-32.73,15.21.98,140.87Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.39,240.07v142.3l111.51,63.79,1.49-.6v-142.51l-113-62.98Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.11,241.24l-22.16-12.73c-2.71-1.25-6.66-1.17-9.17.27l-20.57,11.88c-1.59.92-2.23,2.18-1.94,3.38l56,33.46,44.98,27.61,31.86-18.48-79-45.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.38,300.81v147.14c1.01-.03,2.01-.25,2.78-.7.81-.47,1.21-1.07,1.23-1.68h0v-.03h0v-142.49l-4.01-2.24Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.65,283.96v-1.78h-.57l-.17,1.21.74.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,304.89v-1.82l-.55.77.55,1.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.23,304.73l-101.36-58.52c-5.96-3.44-5.96-9.04,0-12.49l20.57-11.88c5.96-3.44,15.67-3.44,21.63,0l101.36,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.69-1.55-7.06-1.55-9.76,0l-20.57,11.88c-2.69,1.55-2.69,4.08,0,5.63l101.36,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0Z",
    fill: "#1e4a57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,372.2l-52.67-30.41v-52.8l52.67,30.41v52.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.42,283.8c-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.69-1.55-7.06-1.55-9.76,0l-20.57,11.88c-1.76,1.02-2.36,2.45-1.82,3.75.29-.69.89-1.34,1.82-1.88l20.57-11.88c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.2.28-.5.54-.9.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,304.74c-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.57-1.48-4.02-3.37-4.38-5.31-.47,2.56.98,5.22,4.38,7.18l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.2.28-.5.55-.9.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.76,468.6v-142.54s-106.21-59.22-106.21-59.22l-14.86-.98-14.37,9.31-8.81,7.67,103.5,164.12,33.79,19.91,6.96,1.72Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,486.6l31.75-18.33v-137.75l-32.73,15.21.98,140.87Z",
    fill: "#87d0c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,283.95v142.3l111.51,63.79,1.49-.6v-142.51l-113-62.98Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,285.12l-22.16-12.73c-2.71-1.25-6.66-1.17-9.17.27l-20.57,11.88c-1.59.92-2.23,2.18-1.94,3.38l56,33.46,44.98,27.61,31.86-18.48-79-45.39Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.49,344.69v147.14c1.01-.03,2.01-.25,2.78-.7.81-.47,1.21-1.07,1.22-1.68h0v-.03h0v-142.49l-4.01-2.24Z",
    fill: "#61c5bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.77,327.84v-1.78h-.57l-.17,1.21.74.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.5,348.77v-1.82l-.55.77.55,1.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.34,348.61l-101.37-58.52c-5.96-3.44-5.96-9.04,0-12.49l20.57-11.88c5.96-3.44,15.67-3.44,21.63,0l101.36,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.69-1.55-7.06-1.55-9.76,0l-20.57,11.88c-2.69,1.55-2.69,4.08,0,5.63l101.36,58.52c1.64.95,1.64,2.48,0,3.43-1.64.95-4.3.95-5.94,0Z",
    fill: "#d9efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.92,416.08l-52.67-30.41v-52.8l52.67,30.41v52.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.54,327.68c-1.64.95-4.3.95-5.94,0l-101.36-58.52c-2.69-1.55-7.06-1.55-9.76,0l-20.57,11.88c-1.76,1.02-2.36,2.45-1.82,3.75.29-.69.89-1.34,1.82-1.88l20.57-11.88c2.69-1.55,7.06-1.55,9.76,0l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.2.28-.5.54-.9.77Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.28,348.62c-1.64.95-4.3.95-5.94,0l-101.37-58.52c-2.57-1.48-4.02-3.37-4.38-5.31-.47,2.56.98,5.22,4.38,7.18l101.36,58.52c1.64.95,4.3.95,5.94,0,1.24-.72,1.54-1.77.9-2.65-.2.28-.5.55-.9.78Z",
    fill: "#fff"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M274.21,91.2l-63.19-36.48c-1.25-.72-2.38-.75-3.27-.26,0,0,0-.04,0-.04l-6.13,3.54s2.71.99,4.31,1.57v46.02c0,3.74,2.28,8.09,5.08,9.72l60.4,34.87v5.4l6.19-3.57h-.03c1.05-.65,1.72-2.05,1.72-4.06v-46.99c0-3.74-2.27-8.09-5.08-9.72Z",
    fill: "#1e4a57"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M267.96,155.35l-63.19-36.49c-2.81-1.62-5.08-5.97-5.08-9.71v-46.99c0-3.74,2.28-5.46,5.08-3.84l63.19,36.49c2.81,1.62,5.08,5.97,5.08,9.71v46.99c0,3.74-2.28,5.46-5.08,3.84Z",
    fill: "#1e4a57"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M269.52,93.68l-63.19-36.49c-1.78-1.03-3.34-.71-4.25.61.78-.2,1.7-.07,2.7.5l63.19,36.49c2.81,1.62,5.08,5.97,5.08,9.71v46.99c0,1.37-.31,2.47-.84,3.23,1.43-.37,2.39-1.93,2.39-4.35v-46.99c0-3.74-2.28-8.09-5.08-9.71Z",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M226.02,102.67c0,2.72-1.91,3.82-4.26,2.46-2.35-1.36-4.26-4.67-4.26-7.39s1.91-3.82,4.26-2.46c2.35,1.36,4.26,4.67,4.26,7.39Z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M238.94,110.13c0,2.72-1.91,3.82-4.26,2.46-2.35-1.36-4.26-4.67-4.26-7.39s1.91-3.82,4.26-2.46c2.35,1.36,4.26,4.67,4.26,7.39Z",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M251.86,117.58c0,2.72-1.91,3.82-4.26,2.46s-4.26-4.67-4.26-7.39,1.91-3.82,4.26-2.46,4.26,4.67,4.26,7.39Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/login-illustration.893104aca1c54cde7a2bbeaa927d2b3a.svg";
export { ForwardRef as ReactComponent };